import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {} from '@diggens/shared-hooks';
import { useCurrentUser } from '@diggens/user-management';
import { CircularProgress, Box } from '@mui/material';
import { AdminDashboard } from './AdminDashboard';
import { PortCoDashboard } from './PortCoDashboard';

export function Dashboard() {
  const { data: user, isLoading } = useCurrentUser();
  const navigate = useNavigate();

  // A super admin talks to the Chief of Staff of their own tenant, where the onboarding operator works; one who belongs
  // to no tenant has none, so goes to Tenants
  const noChiefOfStaff = user?.role === 'super_admin' && !user.tenant_id;

  useEffect(() => {
    if (noChiefOfStaff) {
      navigate('/super-admin/tenants', { replace: true });
    }
  }, [noChiefOfStaff, navigate]);

  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
        <CircularProgress />
      </Box>
    );
  }

  if (!user) return null;

  if (noChiefOfStaff) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
        <CircularProgress />
      </Box>
    );
  }

  if (user.role === 'admin' || user.role === 'super_admin') return <AdminDashboard />;
  if (user.role === 'portco') return <PortCoDashboard />;

  return null;
}
